<template>
    <section class="container">
        <AtomTitle> Состав системы: </AtomTitle>
        <div class="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4">
            <ProductCard
                v-for="product in items"
                :key="product.slug"
                :product />
        </div>
        <div class="mt-20 text-center max-md:hidden">
            <BaseLink
                :to="`/catalog${catalogCategory ? '#' + catalogCategory : ''}`"
                icon-right="arrow-right"
                size="accent">
                Перейти к каталогу
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import ProductCard from '~/components/particles/product-card/ProductCard.vue'
import type { IProductCard } from '~/components/particles/product-card/product-card.types'

defineProps({
    items: {
        type: Array as PropType<IProductCard[]>,
        default: () => [],
    },
    catalogCategory: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
})
</script>
